<template>
  <div class="navigation-meta">
    <ul class="navigation-meta-list">
      <li
        v-for="(item, i) in navMetaItems"
        :key="i"
        class="navigation-meta-list-item"
      >
        <a
          :href="item.href"
          :target="item.target ? '_blank' : null"
          class="navigation-meta-list-link"
        >
          {{ item.label }}
        </a>
      </li>
      <li class="navigation-meta-list-item">
        <kf-language-selector
          v-if="navMetaLanguages && navMetaCurrentLocale"
          :languages="navMetaLanguages"
          :current-locale="navMetaCurrentLocale"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import KfLanguageSelector from '@/components/language-selector/LanguageSelector.vue';

export default {
  name: 'KfNavigationMeta',
  components: {
    KfLanguageSelector,
  },
  props: {
    navMetaItems: {
      type: Array,
      default: null,
    },
    navMetaLanguages: {
      type: Array,
      default: null,
    },
    navMetaCurrentLocale: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
.navigation {
  &-meta {
    @apply flex items-start relative z-20 ml-auto mb-4;

    &-list {
      @apply flex items-baseline py-4;

      &-item {
        @apply flex ml-8;
      }

      &-link {
        @apply no-underline text-sm text-black;
      }
    }

    &.only-small {
      @apply w-full px-8;

      .navigation-meta-list {
        @apply flex flex-col w-full;

        &-item {
          @apply ml-0;
        }

        &-link,
        .language-selector-link {
          @apply text-primary-bravo text-base mb-2 py-2;
        }
      }

      @screen lg {
        @apply hidden;
      }
    }
  }
}
</style>
